import React from 'react';
import moment from 'moment-timezone';
import AddToCalendar from '@culturehq/add-to-calendar';
import { FormattedMessage } from 'react-intl';

function AddEventToCalendar({ event, settings, className = '' }) {
  const calendarEvent = {
    name: event.get('title'),
    details: event.get('description'),
    location: event.get('type') === 'zoom' ? event.get('url') : event.getIn(['venue', 'name']),
    startsAt: moment.tz(event.getIn(['date', 'start', 'utc']), event.get('timezone')).format(),
    endsAt: moment.tz(event.getIn(['date', 'end', 'utc']), event.get('timezone')).format(),
  };
  return (
    <AddToCalendar event={calendarEvent} filename={event.get('title')} className={className}>
      {settings.get('autoTranslateEvent') ? (
        <FormattedMessage id="add-to-calendar" defaultMessage="Add to Calendar" />
      ) : (
        settings.get('addToCalendarText')
      )}
    </AddToCalendar>
  );
}
export default AddEventToCalendar;
